import BaseIcon from "./base"

/**
 * Icon IoMdPlay from 'react-icons/io'.
 */
export default function PlayIcon({size = 24}) {
    return (
        <BaseIcon size={size}>
            <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 512 512" height="100%" width="100%" xmlns="http://www.w3.org/2000/svg"><path d="M96 52v408l320-204L96 52z"></path></svg>
        </BaseIcon>
    )
}
